import {useState, useEffect} from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Avatar} from '@mui/material';
import {axios} from './axios';
import Background from './assets/6.jpg';
import {Coin} from 'react-cssfx-loading';

const Home = () => {
  const [Data, setData] = useState([]);
  const [Message, setMessage] = useState([]);
  const [Error, setError] = useState(false);
  const [Err404, setErr404] = useState(false)
  const [Counter, setCounter] = useState(7)

  const numberFormat = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
 function mobileAndTabletCheck() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  useEffect(() => {
    
    const interval = setInterval(() => {
      if(Data.length > 0 || Err404)
      {
      if(Counter!=0)
      {
        setCounter(Counter - 1);

      }else
      {
        clearInterval(interval);
        window.location.replace("https://driver.onlinebar.app/verifyPayment");
      }
    }
    }, 1000);
  

    return () => clearInterval(interval);
    });


  useEffect(() => {
    const fetchData = async (params) => {
      setErr404(false)
      try {
        const res = await axios.patch('plans/activate', {
          request_code: params.get(
            'https://payment.onlinebar.app/verify?request_code'
          ),
          tracking_code: params.get('Authority'),
        });
        setError(false);
        const arr = [];
        arr.push(res.data.transaction);
        setData(arr);
        setMessage(res.data.message);
      } catch (err) {
        if (err.response.status != 500)
        {
          setMessage(err.response.data.message);
          setErr404(true)
        }else
        {
          const arr = [];
          arr.push(err.response.data.transaction);
          setData(arr);
          setMessage(err.response.data.message);
          setError(true);
        }
        
      }
    };

    const params = new URLSearchParams(window.location.href);
    fetchData(params)
      // make sure to catch any error
      .catch((err) => console.log(err));
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        display: 'flex',
        // backgroundImage: `url(${Background})`
        backgroundColor: 'rgba(238,238,228,0.51)',
      }}
    >

      {Err404?
      <>
      <Avatar
            alt="Remy Sharp"
            src={require('./assets/logos.png')}
            sx={{width: 152, height: 138, borderRadius: 0}}
          />
           <Typography
            style={{fontFamily: 'IranSans', marginTop: 15}}
            gutterBottom
            variant="h6"
            color={ '#BB2124' }

            component="div"
          >
            {Message}
          </Typography>
          <Button
              onClick={(e)=>window.location.replace("https://driver.onlinebar.app/verifyPayment")}
                style={{fontFamily: 'IranSans', backgroundColor: '#16a085'}}
                variant="contained"
                size="large"
              >
                بازگشت به آنلاین بار
              </Button>
              <Typography
            style={{fontFamily: 'IranSans', marginTop: 15}}
            gutterBottom
            variant="subtitle1"
            component="div"
          >
           {`شما پس از ${Counter} ثانیه به صورت خودکار منتقل می شوید`}
          </Typography>
      </>
      
      :Data.length > 0 ? (
        <>
          <Avatar
            alt="Remy Sharp"
            src={require('./assets/logos.png')}
            sx={{width: 152, height: 138, borderRadius: 0}}
          />
          <Typography
            style={{fontFamily: 'IranSans', marginTop: 15}}
            gutterBottom
            variant="h6"
            component="div"
          >
           {Data['0']?.user?.full_name} عزیز
          </Typography>

          <Typography
            style={{fontFamily: 'IranSans'}}
            gutterBottom
            variant="body1"
            component="div"
            color={Error ? '#BB2124' : '#09c184'}
          >
            {Message}
          </Typography>
          <Card sx={{maxWidth: '90%'}} style={{width:mobileAndTabletCheck()?'80%':'40%'}}>
            <CardContent
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography
                style={{fontFamily: 'IranSans', margin: 0}}
                gutterBottom
                variant="subtitle1"
                component="div"
              >
                رسید پرداخت آنلاین:
              </Typography>
              <Typography
                style={{fontFamily: 'IranSans'}}
                variant="h5"
                color={Error ? '#BB2124' : '#22BB33'}
              >
               {numberFormat(Data['0']?.amount)} ريال
              </Typography>

              <Typography
                style={{fontFamily: 'IranSans',display:Error?'none':'flex'}}
                gutterBottom
                variant="body2"
                component="div"
              >
                از طریق کارت بانکی شما پرداخت شده است
              </Typography>

              <Typography
                              color={Error ? '#BB2124' : '#22BB33'}

                style={{fontFamily: 'IranSans'}}
                gutterBottom
                variant="subtitle1"
                component="div"
              >
                {Error?'پکیج مورد نظر شما فعال نشد':'پکیج مورد نظر شما فعال شد'}
              </Typography>
              <Button
              onClick={(e)=>window.location.replace("https://driver.onlinebar.app/verifyPayment")}
                style={{fontFamily: 'IranSans', backgroundColor: '#16a085'}}
                variant="contained"
                size="large"
              >
                بازگشت به آنلاین بار
              </Button>
              <Typography
            style={{fontFamily: 'IranSans', marginTop: 15}}
            gutterBottom
            variant="subtitle1"
            component="div"
          >
           {`شما پس از ${Counter} ثانیه به صورت خودکار منتقل می شوید`}
          </Typography> 
            </CardContent>
          </Card>
        </>
      ) : <>
        <Coin color="#663053" width="40px" height="40px" duration="2s" />
        <Typography
                              color={'#663053'}

                style={{fontFamily: 'IranSans',marginTop:12}}
                gutterBottom
                variant="subtitle1"
                component="div"
              >
                لطفا چند لحظه صبر کنید...
              </Typography>
        </>
      }
    </div>
  );
};
export default Home;
